module.exports = __webpack_public_path__ + "img/3.63542377.svg";